<metec-web-navigation></metec-web-navigation>
<mes-notification-area></mes-notification-area>
<div class="container-fluid">
  <app-global-status-handling class="z-top d-flex justify-content-center w-100 flex-wrap bottom-if-modal"></app-global-status-handling>
  <mes-web-action-bar></mes-web-action-bar>
  <router-outlet></router-outlet>
</div>
<app-scroll-to-top></app-scroll-to-top>
